const DEFAULT_VOLCANO_AXIS = {
  detection_level: '0',
  effect_size_bounds: '1',
  significance_threshold: '4',
};

export { DEFAULT_VOLCANO_AXIS };
